"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./OloCheckout.css");

var _CheckoutBody = _interopRequireDefault(require("./components/CheckoutBody"));

var OloCheckout = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(OloCheckout, _React$Component);

  function OloCheckout() {
    (0, _classCallCheck2["default"])(this, OloCheckout);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(OloCheckout).apply(this, arguments));
  }

  (0, _createClass2["default"])(OloCheckout, [{
    key: "render",
    value: function render() {
      var trigger = this.props.trigger;
      return _react["default"].createElement(_semanticUiReact.Modal, {
        className: "checkout-modal",
        trigger: trigger,
        dimmer: "inverted"
      }, _react["default"].createElement(_semanticUiReact.Modal.Header, null, "Checkout"), _react["default"].createElement(_semanticUiReact.Modal.Content, null, _react["default"].createElement(_CheckoutBody["default"], this.props)));
    }
  }]);
  return OloCheckout;
}(_react["default"].Component);

exports["default"] = OloCheckout;
;
OloCheckout.propTypes = {
  locationId: _propTypes["default"].number.isRequired,
  cart: _propTypes["default"].shape({
    id: _propTypes["default"].number,
    items: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      selectedVariation: _propTypes["default"].shape({
        id: _propTypes["default"].number,
        menu_item: _propTypes["default"].number,
        name: _propTypes["default"].string,
        order: _propTypes["default"].number,
        price: _propTypes["default"].number
      }),
      selectedModifiers: _propTypes["default"].array,
      specialInstructions: _propTypes["default"].string,
      quantity: _propTypes["default"].number
    }))
  })
};